/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Law7Inputs */

const en__field_enum_tuda_law7 = /** @type {(inputs: _Field_Enum_Tuda_Law7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law, Taxation, Public Administration`)
};

const de__field_enum_tuda_law7 = /** @type {(inputs: _Field_Enum_Tuda_Law7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht, Steuern & Verwaltung`)
};

/**
* | output |
* | --- |
* | "Law, Taxation, Public Administration" |
*
* @param {_Field_Enum_Tuda_Law7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_law7 = /** @type {((inputs?: _Field_Enum_Tuda_Law7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Law7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_law7(inputs)
	return de__field_enum_tuda_law7(inputs)
});
export { _field_enum_tuda_law7 as "_field_enum_TUDA_LAW" }